import {
  AppBar,
  Box,
  Button,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import PropTypes from "prop-types";
import { useContext, useMemo, useState } from "react";

// components
import { IconMenu2, IconShare } from "@tabler/icons";
import { Link } from "react-router-dom";
import { UserContext } from "src/context";
import Logo from "../shared/logo/Logo";
import Profile from "./Profile";

const Header = (props) => {
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const { user, setUser } = useContext(UserContext);
  const [userDefault, setUserDefault] = useState({ user: "" });
  const whatsappShare = "https://api.whatsapp.com/send?text=";
  const shareMessage = `Hello✋

*Do you want to earn Rs.1 Lakh or more💰 from online with 👌0 investment with EarnPati?*

Now you can refer📣 financial products like Bank Account, Demat Account, Credit Cards, Pay Later and more to your friends/family/network🤝 and earn upto ₹3000 commission per successful account opening✅ with EarnPati.

*Download EarnPati app today📲:* https://earnpati.page.link/ocNj

*#AbHarIndiansKamayega*
`;
  useMemo(() => {
    setUserDefault(JSON.parse(localStorage.getItem("store")));
    // if (!user) {
    //   setUser(JSON.parse(localStorage.getItem('store')).user);
    // }
  }, []);
  // const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const AppBarStyled = styled(AppBar)(({ theme }) => ({
    boxShadow: "none",
    background: theme.palette.background.paper,
    justifyContent: "center",
    backdropFilter: "blur(4px)",
    width: "80vw",
    minWidth: "100%",
    left: "0px",
    [theme.breakpoints.up("lg")]: {
      minHeight: "70px",
    },
  }));
  const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
    color: theme.palette.text.secondary,
  }));

  return (
    <AppBarStyled
      position="sticky"
      color="info"
      sx={{ width: { xs: "98vw", lg: "70vw" } }}
    >
      {lgDown ? (
        <ToolbarStyled>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            sx={{ width: "90%", position: "relative" }}
          >
            <Stack
              direction={"row"}
              spacing={1}
              sx={{ maxWidth: "70%" }}
              alignItems={"center"}
            >
              <Box />
              <Stack spacing={1} direction="row" alignItems="center">
                <Profile user={userDefault.user} />
              </Stack>

              <Typography>
                Hey{" "}
                <span
                  style={{
                    fontWeight: 700,
                    color: "#222",
                    fontSize: "1rem",
                    verticalAlign: "top",
                    paddingTop: "15px",
                    marginLeft: "5px",
                  }}
                >
                  {userDefault?.user?.name || user?.user?.name}
                </span>
                <br />
                Welcome to EarnPati
              </Typography>
            </Stack>
            <Stack direction={"row"} alignItems={"center"}>
              <Link
                to={`${whatsappShare}${encodeURIComponent(shareMessage)}`}
                target="_blank"
              >
                <IconShare />
              </Link>
            </Stack>
          </Stack>
        </ToolbarStyled>
      ) : (
        <ToolbarStyled>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            sx={{ width: "90%", position: "relative" }}
          >
            <Stack direction={"row"} spacing={1} sx={{ maxWidth: "30%" }}>
              <IconButton
                color="inherit"
                aria-label="menu"
                onClick={props.toggleMobileSidebar}
                sx={{
                  // display: {
                  //   lg: "none",
                  //   xs: "inline",
                  // },
                  display: "none",
                }}
              >
                <IconMenu2 />
              </IconButton>
              <IconButton
                sx={{
                  display: {
                    lg: "none",
                    xs: "inline",
                  },
                }}
              >
                <Logo link={"/"} />
              </IconButton>
            </Stack>

            <Stack direction={"row"} spacing={1} sx={{ maxWidth: "40%" }}>
              <Box />
              <Stack spacing={1} direction="row" alignItems="center">
                {userDefault && userDefault?.user?.role && userDefault?.user?.role.includes("admin") ? (
                  <Typography
                    component={Link}
                    to={
                      window.location.pathname.includes("admin")
                        ? "/dashboard"
                        : "/admin"
                    }
                  >
                    <Button variant="text">
                      {window.location.href.includes("admin")
                        ? "User"
                        : "Admin"}
                    </Button>
                  </Typography>
                ) : null}
                <Profile user={userDefault?.user} />
              </Stack>
            </Stack>
          </Stack>
        </ToolbarStyled>
      )}
    </AppBarStyled>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
};

export default Header;
